var ENCODE = typeof btoa !== "undefined" ? btoa : typeof Buffer !== "undefined" ? function (str) {
  return Buffer.from(str).toString("base64");
} : function (str) {
  return str;
};
var RELAY_ARGS = ["after", "before", "first", "last"];

function getIndexOfRecord(records, cursor, typeName, encode) {
  var index = null;
  if (cursor == null) return index;

  for (var i = 0; i < records.length; i++) {
    if (encode("".concat(typeName, ":").concat(records[i].id)) === cursor) {
      index = i;
      break;
    }
  }

  return index;
}

function hasField(type, fieldName) {
  return fieldName in type.getFields();
}

export function getEdges(records, args, typeName) {
  var encode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ENCODE;
  var after = args.after,
      before = args.before,
      first = args.first,
      last = args.last;
  var afterIndex = getIndexOfRecord(records, after, typeName, encode);
  var beforeIndex = getIndexOfRecord(records, before, typeName, encode);
  if (afterIndex != null) records = records.slice(afterIndex + 1);
  if (beforeIndex != null) records = records.slice(0, beforeIndex);
  if (first != null) records = records.slice(0, first);
  if (last != null) records = records.slice(-last);
  return records.map(function (record) {
    return {
      cursor: encode("".concat(typeName, ":").concat(record.id)),
      node: record
    };
  });
}
export function getPageInfo(records, edges) {
  var pageInfo = {
    hasPreviousPage: false,
    hasNextPage: false,
    startCursor: null,
    endCursor: null
  };

  if (edges && edges.length) {
    var firstEdge = edges[0];
    var lastEdge = edges[edges.length - 1];
    pageInfo.startCursor = firstEdge.cursor;
    pageInfo.endCursor = lastEdge.cursor;
    pageInfo.hasPreviousPage = firstEdge.node.id !== records[0].id;
    pageInfo.hasNextPage = lastEdge.node.id !== records[records.length - 1].id;
  }

  return pageInfo;
}
export function getRelayArgs(args) {
  return Object.keys(args).reduce(function (separatedArgs, arg) {
    var argsSet = RELAY_ARGS.includes(arg) ? "relayArgs" : "nonRelayArgs";
    separatedArgs[argsSet][arg] = args[arg];
    return separatedArgs;
  }, {
    relayArgs: {},
    nonRelayArgs: {}
  });
}
export function isRelayConnectionType(type) {
  return type.name.endsWith("Connection") && hasField(type, "edges");
}
export function isRelayEdgeType(type) {
  return type.name.endsWith("Edge") && hasField(type, "node");
}
export function isRelayPageInfoType(type) {
  return type.name === "PageInfo" && hasField(type, "startCursor");
}
export function isRelayType(type) {
  return type.name && (isRelayConnectionType(type) || isRelayEdgeType(type) || isRelayPageInfoType(type));
}
